module.exports = __webpack_public_path__ + "img/Closed_water_supply_installation.f61a64e1.jpg";